import React from 'react';
import { Select } from 'antd';

import { useEmailTagList } from 'api/mappings';
import { InputLimitWidth } from 'components/Layout/Form';
import { FlexContainer } from 'components/Layout/common';
import { TRuleCreatePage } from 'containers/Rule/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

interface Props {
  getValue: (key: string) => any;
  setValue: (key: string, value: any) => void;
}

const EmailTags = (props: Props) => {
  const { getValue, setValue } = props;
  const { data: emailTags = [] } = useEmailTagList();
  const response = { data: emailTags };

  const { t } = useMultiLanguageTranslation();

  return (
    <FlexContainer>
      <div>
        <InputLimitWidth>
          <Select
            value={getValue('filters.email_tags.criteria.policy')}
            onSelect={value => setValue('filters.email_tags.criteria.policy', value)}
            placeholder={t(
              `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.EmailTagsFilter.Includes`
            )}
          >
            <Select.Option value="include">
              {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.EmailTagsFilter.Includes`)}
            </Select.Option>
            <Select.Option value="exclude">
              {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.EmailTagsFilter.Excludes`)}
            </Select.Option>
          </Select>
        </InputLimitWidth>
      </div>
      <div style={{ flex: '1 1 auto' }}>
        <Select
          value={getValue('filters.email_tags.criteria.json_values')}
          mode="multiple"
          showArrow={true}
          onChange={value => setValue('filters.email_tags.criteria.json_values', value)}
          placeholder={t(
            `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.EmailTagsFilter.SelectEmailTags`
          )}
        >
          {response?.data.map((emailTag, index) => {
            return (
              <Select.Option value={`${emailTag?.name}`} key={index}>
                {emailTag?.name}
              </Select.Option>
            );
          })}
        </Select>
      </div>
    </FlexContainer>
  );
};

export default EmailTags;
